// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1zMog","col":"styles_col__2S2c4","fulfillmentStatus":"styles_fulfillmentStatus__2mcYQ","emailCol":"styles_emailCol__38Zdw"};